import { timestampsMap } from "./timestamps";

export const professionalMap: GenericObject = {
	nome: "name",
	sexo: "gender",
	matricula: "registration",
	numero_conselho: "councilNumber",
	ativado: "active",
	codprofcnes: "cnesProfCode",
	imgperfil: "profileImg",
	telefone: "phone",
	data_nasc: "birthDate",
	cod_cartao: "cardCode",
	autenticador: "authenticator",
	unidade_id: "unitId",
	pais: "country",
	uf: "state",
	cidade: "city",
	tipo_logradouro: "addressType",
	logradouro: "address",
	numero: "number",
	complemento: "complement",
	bairro: "neighborhood",
	vinculo: "bond",
	notificacao: "notification",
	setor_id: "departmentId",
	profile_logado: "loggedProfile",
	last_seen: "lastSeen",
	last_session_id: "lastSessionId",
	especialidade_id: "expertiseId",
	profile_name: "profileName",
	...timestampsMap,
};
